import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Screens a demo account has no business on, whatever it types into the address bar.
 *
 * Hiding something from the nav is not the same as closing it: a bookmark, a shared link or a
 * guess still opens the page, and it then fills with 403s from a server that has already made up
 * its mind (`DemoRestrictionFilter`). Submissions in particular are other people's answers, and a
 * demo builds in a shared environment where "their own" is not a category that means anything.
 *
 * Sent back to /flows, which is the whole of what a demo account is for. Lives beside
 * ProtectedRoute because it is the same kind of thing: who is allowed through a door.
 */
const AccountOnlyRoute = ({ children }) => {
  const { isDemoMode } = useAuth();
  return isDemoMode ? <Navigate to="/flows" replace /> : children;
};

export default AccountOnlyRoute;
